import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { SurveyPopoverComponent } from './survey-popover.component';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, MatIconModule],
  declarations: [SurveyPopoverComponent],
  exports: [SurveyPopoverComponent],
})
export class SurveyPopoverModule {}
